var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineConvert3DCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.35 22.37a.745.745 0 0 1 .01-.75l1.05-1.75c.21-.36.67-.47 1.03-.26.36.21.47.67.26 1.03l-.27.45c2.76-.65 4.83-3.13 4.83-6.09 0-.41.34-.75.75-.75s.75.34.75.75c-.01 4.27-3.49 7.75-7.76 7.75-.27 0-.52-.15-.65-.38zM1.25 9c0-4.27 3.48-7.75 7.75-7.75a.745.745 0 0 1 .64 1.13L8.59 4.13c-.21.36-.67.47-1.03.26a.749.749 0 0 1-.26-1.03l.27-.45C4.81 3.56 2.74 6.04 2.74 9a.74.74 0 0 1-.74.75c-.41 0-.75-.34-.75-.75zM17.3 7.4l-3.97-2.3a.752.752 0 0 1-.27-1.03c.21-.36.67-.48 1.02-.27l3.6 2.08 3.57-2.07c.36-.21.82-.08 1.02.27.21.36.08.82-.27 1.03l-3.95 2.28c-.11.07-.24.11-.37.11s-.26-.03-.38-.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.93 10.82V6.74c0-.41.34-.75.75-.75s.75.34.75.75v4.08a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.38 11.44-2.4-1.33c-.78-.43-1.37-1.44-1.37-2.33V5.24c0-.9.59-1.9 1.38-2.34l2.4-1.33c.74-.41 1.85-.41 2.6 0l2.4 1.33c.78.43 1.37 1.44 1.37 2.33v2.54c0 .9-.59 1.9-1.37 2.33l-2.4 1.33c-.39.22-.85.32-1.31.32-.46 0-.93-.1-1.3-.31zM14.71 4.2c-.3.17-.6.68-.6 1.02v2.54c0 .35.3.86.6 1.02l2.4 1.34c.29.16.85.16 1.14 0l2.4-1.33c.3-.17.6-.68.6-1.02V5.23c0-.35-.3-.86-.6-1.02l-2.4-1.33c-.29-.17-.86-.17-1.14-.01l-2.4 1.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.941 18.4-3.97-2.3a.752.752 0 0 1-.27-1.03c.21-.36.67-.48 1.02-.27l3.6 2.08 3.57-2.07c.36-.21.82-.08 1.02.27.21.36.08.82-.27 1.03l-3.95 2.28c-.11.07-.24.11-.37.11s-.26-.03-.38-.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57 21.82v-4.08c0-.41.34-.75.75-.75s.75.34.75.75v4.08c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.02 22.44-2.4-1.33c-.78-.43-1.37-1.44-1.37-2.33v-2.54c0-.9.59-1.9 1.37-2.33l2.4-1.33c.74-.41 1.86-.41 2.6 0l2.4 1.33c.78.43 1.37 1.44 1.37 2.33v2.54c0 .9-.59 1.9-1.38 2.34l-2.4 1.33c-.36.2-.82.3-1.29.3-.46 0-.93-.1-1.3-.31zM3.35 15.2c-.3.17-.6.68-.6 1.02v2.54c0 .35.3.86.6 1.02l2.4 1.33c.29.16.85.16 1.14 0l2.4-1.33c.3-.17.6-.68.6-1.02v-2.54c0-.35-.3-.86-.6-1.02l-2.4-1.34c-.28-.15-.85-.15-1.14.01l-2.4 1.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineConvert3DCube);
export default __webpack_public_path__ + "static/media/vuesax-outline-convert-3-d-cube.8e0025d25df86332a5c11ec5a2515f7e.svg";
export { ForwardRef as ReactComponent };